module.exports = __webpack_public_path__ + "img/f7.341da316.png";